import Button from '@atlaskit/button/standard-button';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import React, { useEffect, useState } from 'react';
import { ANALYTICS_EXPANDER_UI_CLICKED } from '../../analytics';
import { usePrivacySecurityAnalytics } from '../../hooks/usePrivacySecurityAnalytics';
import { jsx as _jsx } from "react/jsx-runtime";
const Expander = _ref => {
  let {
    totalCount,
    text,
    maxCount,
    onChange,
    className
  } = _ref;
  const hasMorePointsThanLimit = totalCount > maxCount;
  const [showExpanderButton, setShowExpanderButton] = useState(hasMorePointsThanLimit);
  const {
    fireButtonEvent
  } = usePrivacySecurityAnalytics();
  const expanderClicked = () => {
    setShowExpanderButton(false);
    onChange(totalCount);
    fireButtonEvent(ANALYTICS_EXPANDER_UI_CLICKED, {
      expanderText: text
    });
  };
  useEffect(() => {
    const numberOfPointsVisible = showExpanderButton ? maxCount : totalCount;
    // onMount do first render of all the items
    onChange(numberOfPointsVisible);
  }, []);
  return showExpanderButton ? /*#__PURE__*/_jsx(Button, {
    spacing: "none",
    iconAfter: /*#__PURE__*/_jsx(ChevronDownIcon, {
      size: "medium"
    }),
    appearance: "link",
    onClick: expanderClicked,
    className: className,
    children: text
  }) : null;
};
export default Expander;